module.exports = __webpack_public_path__ + "static/img/certificate2.6ea5e5e5.png";